<template>
  <div class="row">
    <div class="col-4">
      <!-- Firm Name -->
      <div class="row">
        <div class="col">
          <span class="custom-firmname">{{ firm.firmName }}</span>
        </div>
      </div>
      <!-- Firm Ids -->
      <div class="row">
        <div class="col">
          <table class="custom-ids-table">
            <thead>
              <tr class="custom-ids-table-header">
                <th>Number</th>
                <th>Id</th>
                <th>Estimating Id</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ firmNumber }}</td>
                <td>{{ firmId }}</td>
                <td>{{ estimatingId }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col custom-ids-wrapper">
      <!-- Firm Contact Info -->
      <div class="row">
        <div class="col">
          {{ contactName }}
        </div>
        <div class="col">
          {{ contactEmail }}
        </div>
      </div>
      <!-- Firm Address, Phone -->
      <div class="row">
        <div class="col">
          <table>
            <tbody>
              <tr>
                <td>{{ addressLines }}</td>
              </tr>
              <tr>
                <td>{{ cityStateZip }}</td>
                <td>{{ country }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col">
          {{ phone }}
        </div>
      </div>
      <span class="custom-id">{{ firmFirm }}</span>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
export default {
  name: 'MemberDetail',
  props: {
    firm: Object
  },
  data() {
    return {
      // Your data properties here
    }
  },
  mounted() {
    // Your mounted code here
    this.getMemberDetails()
  },
  computed: {
    ...mapState(locationStore, ['loading', 'member']),
    firmNumber() {
      let _data = null
      if (this.member) {
        _data = this.member.firmNumber
      }
      return _data
    },
    firmFirm() {
      let _data = null
      if (this.firm) {
        _data = this.firm.firmFirm
      }
      return _data
    },
    firmId() {
      let _data = null
      if (this.member) {
        _data = this.member.firm
      }
      return _data
    },
    estimatingId() {
      let _data = null
      if (this.member) {
        _data = this.member.estimatingId
      }
      return _data
    },
    contactName() {
      let _data = null
      if (this.member) {
        if (this.member.contact) {
          _data = `${this.member.contact.firstname} ${this.member.contact.lastname}`
        }
      }
      return _data
    },
    contactEmail() {
      let _data = null
      if (this.member) {
        if (this.member.contact) {
          _data = this.member.contact.emailAddress
        }
      }
      return _data
    },
    addressLines() {
      let _data = null
      if (this.member) {
        if (this.member.address) {
          _data = this.member.address.addressLines
        }
      }
      return _data
    },
    cityStateZip() {
      let _data = null
      if (this.member) {
        if (this.member.address) {
          _data = `${this.member.address.city}, ${this.member.address.stateProvinceName} ${this.member.address.postalCode}`
        }
      }
      return _data
    },
    country() {
      let _data = null
      if (this.member) {
        if (this.member.address) {
          _data = this.member.address.country
        }
      }
      return _data
    },
    phone() {
      let _data = null
      if (this.member) {
        if (this.member.phone) {
          _data = `${this.member.phone.phoneNo} ${this.member.phone.extension}`.trim()
        }
      }
      return _data
    }
  },
  methods: {
    ...mapActions(locationStore, ['getMember']),
    async getMemberDetails() {
      if (this.firm) {
        console.log('Getting Member', this.firm)
        await this.getMember({
          parent: this.firm.parent,
          firm: this.firm.firm,
          source: this.firm.source
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-ids-wrapper {
  position: relative;
}
.custom-firmname {
  font-size: 1.1em;
  font-weight: bold;
}
.custom-ids-table {
  width: 400px;
}
.custom-ids-table-header {
  font-style: italic;
}
.custom-id {
  position: absolute;
  bottom: 0;
  right: 15px;
  font-size: 0.8em;
}
</style>
